import { useCampfireQuery } from '../../global/network/useCampfireQuery';
import { GET_ONBOARDING_OPTION_STAGES } from './onboarding-option-stages-model.gql';
import { GetOnboardingOptionStages } from './__generated__/GetOnboardingOptionStages';

export const ONBOARDING_OPTION_TYPES = {
  activityPreferences: 'activity_preferences',
  availabilitySimple: 'availability_simple',
  availabilityComplex: 'availability_complex',
  roleApplications: 'role_applications',
} as const;

export type OnboardingOptionType = typeof ONBOARDING_OPTION_TYPES[keyof typeof ONBOARDING_OPTION_TYPES];

export interface OnboardingOptionContent {
  title?: string | null;
  description?: string | null;
}

export const useOnboardingOptionContent = (optionType: OnboardingOptionType): OnboardingOptionContent => {
  const { data } = useCampfireQuery<GetOnboardingOptionStages, {}>(GET_ONBOARDING_OPTION_STAGES);

  const stage = data?.vm.onboardingOptionStages.find((s) => s.optionType === optionType);

  return {
    title: stage?.customTitle ?? null,
    description: stage?.customDescription ?? null,
  };
};
